import { render, staticRenderFns } from "./headerProfile.vue?vue&type=template&id=4b9756ca&scoped=true&"
import script from "./headerProfile.vue?vue&type=script&lang=js&"
export * from "./headerProfile.vue?vue&type=script&lang=js&"
import style0 from "./headerProfile.vue?vue&type=style&index=0&id=4b9756ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9756ca",
  null
  
)

export default component.exports